import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useNavigateWithSearchContext } from '../../hooks/useNavigateWithSearchContext';
import './FloatingButtons.css';

const FloatingButtons: React.FC = () => {
  const navigate = useNavigate();
  const navigateWithContext = useNavigateWithSearchContext();

  const handleLegalClick = () => {
    navigate('/legal');
  };

  const handlePricingClick = () => {
    navigateWithContext('/pricing');
  };

  const handleContactClick = () => {
    navigate('/contact');
  };

  const handleHomeClick = () => {
    navigate('/');
  };

  return (
    <div className="floating-buttons">
      <button 
        className="floating-button home-button"
        onClick={handleHomeClick}
        title="Back to Home"
      >
        <svg 
          width="16" 
          height="16" 
          viewBox="0 0 24 24" 
          fill="none" 
          stroke="currentColor" 
          strokeWidth="2" 
          strokeLinecap="round" 
          strokeLinejoin="round"
        >
          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
          <polyline points="9,22 9,12 15,12 15,22"/>
        </svg>
        <span>Home</span>
      </button>
      
      <button 
        className="floating-button legal-button"
        onClick={handleLegalClick}
        title="Legal & Privacy"
      >
        <svg 
          width="16" 
          height="16" 
          viewBox="0 0 24 24" 
          fill="none" 
          stroke="currentColor" 
          strokeWidth="2" 
          strokeLinecap="round" 
          strokeLinejoin="round"
        >
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
          <polyline points="14,2 14,8 20,8"/>
          <line x1="16" y1="13" x2="8" y2="13"/>
          <line x1="16" y1="17" x2="8" y2="17"/>
          <polyline points="10,9 9,9 8,9"/>
        </svg>
        <span>Legal</span>
      </button>
      
      <button 
        className="floating-button floating-pricing-button"
        onClick={handlePricingClick}
        title="Pricing Plans"
      >
        <svg 
          width="16" 
          height="16" 
          viewBox="0 0 24 24" 
          fill="none" 
          stroke="currentColor" 
          strokeWidth="2" 
          strokeLinecap="round" 
          strokeLinejoin="round"
        >
          <line x1="12" y1="1" x2="12" y2="23"/>
          <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
        </svg>
        <span>Pricing</span>
      </button>

      <button 
        className="floating-button contact-button"
        onClick={handleContactClick}
        title="Contact Us"
      >
        <svg 
          width="16" 
          height="16" 
          viewBox="0 0 24 24" 
          fill="none" 
          stroke="currentColor" 
          strokeWidth="2" 
          strokeLinecap="round" 
          strokeLinejoin="round"
        >
          <rect x="3" y="5" width="18" height="14" rx="2" ry="2" />
          <polyline points="3,7 12,13 21,7" />
        </svg>
        <span>Contact Us</span>
      </button>
    </div>
  );
};

export default FloatingButtons; 